// extracted by mini-css-extract-plugin
export default {"block":"MediumText_block__2Jqt3"};